
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Wagholitomumbaicabservice() {



    const cardData =
    {
        keyword: 'Wagholi to Mumbai Cab Service',
        heading: 'Meghana Cab : Wagholi to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Wagholi to Mumbai Cab Service, delivering a reliable and convenient travel solution from Pune’s fast-growing suburb to the city of Mumbai. Whether you’re heading out for a business trip, airport transfer, or weekend getaway, our wide range of vehicles—including Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers—ensures a comfortable journey for every traveler. With on-time pickups from Wagholi, experienced drivers, transparent pricing, and 24/7 customer support, Meghana Cab guarantees a smooth and stress-free intercity ride. Book your Wagholi to Mumbai Cab today for safe, comfortable, and affordable travel.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

    "services": [
    {
      "name": "Wagholi to Mumbai Taxi Booking",
      "description": "Book your taxi from Wagholi to Mumbai effortlessly with our user-friendly online platform. Enjoy instant confirmation, multiple payment options, and reliable customer support for a smooth booking experience."
    },
    {
      "name": "One Way Cab Wagholi to Mumbai",
      "description": "Choose our one-way cab service from Wagholi to Mumbai for direct and comfortable travel. Ideal for personal or business trips, we ensure punctual pickups and safe journeys with experienced drivers."
    },
    {
      "name": "Round Trip Wagholi to Mumbai Cab",
      "description": "Plan your round trip between Wagholi and Mumbai with our flexible and affordable cab service. Perfect for business meetings, family visits, or leisure travel with guaranteed availability both ways."
    },
    {
      "name": "Online Cab Hire Wagholi to Mumbai",
      "description": "Secure your cab online from Wagholi to Mumbai anytime, anywhere. Our platform offers transparent pricing, vehicle options ranging from sedans to SUVs, and a seamless booking process for your convenience."
    },
    {
      "name": "Budget Travel Cab Wagholi to Mumbai",
      "description": "Travel economically with our budget-friendly cabs from Wagholi to Mumbai. Experience clean, well-maintained vehicles and courteous drivers without compromising comfort or safety."
    },
    {
      "name": "AC Sedan Wagholi to Mumbai",
      "description": "Hire an air-conditioned sedan for your Wagholi to Mumbai trip and enjoy a smooth, comfortable ride. Our sedans are perfect for solo travelers or small groups seeking premium comfort."
    },
    {
      "name": "SUV Taxi Wagholi to Mumbai",
      "description": "Opt for an SUV taxi when traveling from Wagholi to Mumbai, offering ample space for groups and luggage. Perfect for family trips or business travel with added comfort and style."
    },
    {
      "name": "Private Cab Wagholi to Mumbai",
      "description": "Enjoy the exclusivity of a private cab from Wagholi to Mumbai. Customize your itinerary, avoid unnecessary stops, and travel at your own pace with a dedicated vehicle and driver."
    },
    {
      "name": "Chauffeur Service Wagholi to Mumbai",
      "description": "Experience professional chauffeur-driven cab services from Wagholi to Mumbai. Our well-trained drivers ensure your safety, comfort, and timely arrival at your destination."
    },
    {
      "name": "Corporate Trip Cab Wagholi to Mumbai",
      "description": "Reliable and punctual corporate cab services for business travelers commuting between Wagholi and Mumbai. Focus on your work while we handle your transportation needs efficiently."
    },
    {
      "name": "Reliable Taxi Wagholi to Mumbai",
      "description": "Count on our dependable taxi service for consistent, timely rides from Wagholi to Mumbai. We prioritize vehicle maintenance and driver professionalism for your peace of mind."
    },
    {
      "name": "Family Cab Wagholi to Mumbai",
      "description": "Family-friendly cabs with spacious interiors and safety features to make your Wagholi to Mumbai journey comfortable and enjoyable for all members of your family."
    },
    {
      "name": "Fast Cab Booking Wagholi to Mumbai",
      "description": "Need a cab on short notice? Our fast booking service ensures quick allocation of taxis from Wagholi to Mumbai, minimizing your wait time and enhancing convenience."
    },
    {
      "name": "Long Drive Wagholi to Mumbai Cab",
      "description": "Planning a long drive? Our Wagholi to Mumbai cab service offers comfortable vehicles and skilled drivers for a relaxed and enjoyable road trip experience."
    },
    {
      "name": "24/7 Cab Service Wagholi to Mumbai",
      "description": "Our round-the-clock cab service from Wagholi to Mumbai ensures you can book a taxi any time of the day or night, catering to urgent or unscheduled travel needs."
    }
  ],
  "tableData": [
    ["Wagholi to Mumbai Taxi Booking", "One Way Cab Wagholi to Mumbai"],
    ["Round Trip Wagholi to Mumbai Cab", "Online Cab Hire Wagholi to Mumbai"],
    ["Budget Travel Cab Wagholi to Mumbai", "AC Sedan Wagholi to Mumbai"],
    ["SUV Taxi Wagholi to Mumbai", "Private Cab Wagholi to Mumbai"],
    ["Chauffeur Service Wagholi to Mumbai", "Corporate Trip Cab Wagholi to Mumbai"],
    ["Reliable Taxi Wagholi to Mumbai", "Family Cab Wagholi to Mumbai"],
    ["Fast Cab Booking Wagholi to Mumbai", "Long Drive Wagholi to Mumbai Cab"],
    ["24/7 Cab Service Wagholi to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Trusted Wagholi to Mumbai Cab Service for All Travel Needs",
        "WhyChoosedescription": "Our Wagholi to Mumbai cab service offers a dependable and stress-free travel solution. Whether you’re heading to the airport, a business meeting, or a family gathering, we ensure a smooth ride with on-time pickup and drop-off right from your doorstep."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
        "WhyChoosedescription": "We offer a fleet of sedans, SUVs, and premium cars, all equipped with air-conditioning, plush seating, and ample luggage space. Each vehicle is thoroughly cleaned and regularly serviced for a safe and pleasant journey, even during long hours on the road."
    },
    {
        "WhyChooseheading": "Experienced, Courteous, and Background-Verified Drivers",
        "WhyChoosedescription": "Our professional drivers are well-trained, polite, and familiar with all the routes between Wagholi and Mumbai. They prioritize your safety and comfort while ensuring timely arrival and efficient navigation through city traffic or highway conditions."
    },
    {
        "WhyChooseheading": "All-Inclusive and Transparent Pricing",
        "WhyChoosedescription": "Enjoy peace of mind with upfront pricing that includes tolls, fuel, taxes, and driver charges. There are no hidden fees or last-minute costs—just simple, honest pricing that fits your budget and makes planning easy."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Your Schedule",
        "WhyChoosedescription": "Book a one-way trip, a same-day return, or even a multi-day round trip. We offer complete flexibility, letting you customize your journey according to your schedule and travel needs. Choose your pickup time and destination easily."
    },
    {
        "WhyChooseheading": "Convenient Door-to-Door Pickup and Drop-off",
        "WhyChoosedescription": "No need to travel to a pickup point. Our driver will come right to your home, office, or hotel in Wagholi and drop you off at your exact location in Mumbai, whether it’s the airport, a business hub, or a residential area."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Business Trips & Family Travel",
        "WhyChoosedescription": "Whether you're heading to Mumbai International Airport with luggage, traveling with colleagues for meetings, or taking your family for a weekend getaway, our cab service offers the space, reliability, and service quality you need."
    },
    {
        "WhyChooseheading": "24/7 Booking and Support Assistance",
        "WhyChoosedescription": "Book your Wagholi to Mumbai cab any time—day or night—using our online platform or by speaking with our responsive customer support team. We're available 24/7 to assist with reservations, route adjustments, or any special travel needs."
    }
]











    }

const faqData = [
    {
        question: "How can I book a cab from Wagholi to Mumbai?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or through our website for easy online booking."
    },
    {
        question: "What is the estimated travel time from Wagholi to Mumbai by cab?",
        answer: "The journey usually takes around 3.5 to 4.5 hours depending on traffic conditions."
    },
    {
        question: "Are one way and round trip cab services available from Wagholi to Mumbai?",
        answer: "Yes, we offer both one way and round trip services to accommodate your travel plans."
    },
    {
        question: "What types of vehicles can I choose for Wagholi to Mumbai cab service?",
        answer: "We provide hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers based on your requirements."
    },
    {
        question: "Is the Wagholi to Mumbai cab service available 24/7?",
        answer: "Yes, our cab services operate round the clock to serve you anytime."
    },
    {
        question: "What does the fare for Wagholi to Mumbai cab include?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional parking or waiting charges may apply."
    },
    {
        question: "Can I book a cab from Wagholi to Mumbai on short notice?",
        answer: "Yes, last-minute bookings are accepted based on vehicle availability. Please call for prompt assistance."
    },
    {
        question: "Is online booking available for Wagholi to Mumbai cab service?",
        answer: "Yes, you can book your cab online anytime via our website."
    },
    {
        question: "Can I request stops during the journey for food or rest?",
        answer: "Yes, you can request stops during the trip. Inform us when booking or notify the driver during travel."
    },
    {
        question: "Are your drivers experienced with the Wagholi to Mumbai route?",
        answer: "Absolutely. Our drivers are skilled, verified, and knowledgeable about the best routes."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Abhijeet Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable and comfortable cab service from Wagholi to Mumbai. The driver was punctual and courteous.”',
    },
    {
        name: 'Ms. Anjali Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience with Meghana Cab. Clean car and smooth journey from Wagholi to Mumbai.”',
    },
];

































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wagholi to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/wagholi-to-mumbai-cab.jpg",
  "description": "Book dependable Wagholi to Mumbai cab service with Meghana Cabs. Offering budget, AC sedan, SUV, and chauffeur-driven taxis for one-way and round trips. Perfect for family, corporate, and long-distance travel. Available 24/7 with online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1950",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/wagholi-to-mumbai-cab-service"
  }
};









    return (
        <div>

<Helmet>
  <title>Wagholi to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book dependable Wagholi to Mumbai cab service with Meghana Cabs. Offering budget, AC sedan, SUV, and chauffeur-driven taxis for one-way and round trips. Perfect for family, corporate, and long-distance travel. Available 24/7 with online booking." 
  />
  <meta 
    name="keywords" 
    content="Wagholi to Mumbai Taxi Booking, One Way Cab Wagholi to Mumbai, Round Trip Wagholi to Mumbai Cab, Online Cab Hire Wagholi to Mumbai, Budget Travel Cab Wagholi to Mumbai, AC Sedan Wagholi to Mumbai, SUV Taxi Wagholi to Mumbai, Private Cab Wagholi to Mumbai, Chauffeur Service Wagholi to Mumbai, Corporate Trip Cab Wagholi to Mumbai, Reliable Taxi Wagholi to Mumbai, Family Cab Wagholi to Mumbai, Fast Cab Booking Wagholi to Mumbai, Long Drive Wagholi to Mumbai Cab, 24/7 Cab Service Wagholi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Wagholitomumbaicabservice;